import { render, staticRenderFns } from "./ProductOptionImageAddForm.vue?vue&type=template&id=a1c066b8&scoped=true&"
import script from "./ProductOptionImageAddForm.vue?vue&type=script&lang=ts&"
export * from "./ProductOptionImageAddForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProductOptionImageAddForm.vue?vue&type=style&index=0&id=a1c066b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c066b8",
  null
  
)

export default component.exports